import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import PageHeading from "@/v2/components/ui/heading/Page";
import parseUrlToQueryParams from "../../utils/parseUrlToQueryParams";
import { DataTable, TableToolbar } from "@/v2/components/data-table/table";
import { Supplier } from "@/v2/types";
import ExportSupplier from "@/v2/api/supplier/Export";
import FindAllPendingSupplier from "@/v2/api/supplier/FindAllPending";
import {
    ApproveSuppliersColumn,
    ApproveSuppliersFilterColumn,
} from "@/v2/components/data-table/columns/ApproveSupplier";

export default function ApprovalSupplierPage() {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);

    const { skip, limit, search, filter } = queryParams;

    const { refetch, ...query } = useQuery({
        queryKey: ["onboard-suppliers", skip, limit, search, filter],
        queryFn: () =>
            FindAllPendingSupplier({
                limit: limit ?? 20,
                skip: skip ?? 0,
                search: search,
                filter,
            }),
    });

    return (
        <>
            <div className="flex flex-wrap items-center justify-between gap-4 py-2">
                <PageHeading
                    title="Onboard Supplier"
                    description="Manage and monitor all onboard requests in your platform"
                />
            </div>

            <Card className="p-2">
                <TableToolbar<Supplier>
                    column={ApproveSuppliersFilterColumn}
                    searchPlaceHolder="Search onboard requests.."
                    exportFileName="onboard-requests"
                    exportFunc={() => ExportSupplier({ filter })}
                />

                <DataTable<Supplier>
                    data={query.data?.data || []}
                    columns={ApproveSuppliersColumn}
                    loading={query.isLoading || query.isFetching}
                    pagination={query?.data?.pagination!}
                />
            </Card>
        </>
    );
}
